module.exports = __webpack_public_path__ + "static/media/SmartShop_5-572w.37e8505f.png";